export class AssetsPermissions {
	see: boolean;
	upload: boolean;
	destroy: boolean;
	approve: boolean;
	seeVersions: boolean;
	filter: boolean;
	editTitle: boolean;
	moveItemsAcrossAllLevels: boolean;
	assignCollaborators: boolean;
	deleteLastRoundAnyUploader: boolean;

	constructor( {
		see = false,
		upload = false,
		destroy = false,
		approve = false,
		seeVersions = false,
		filter = false,
		editTitle = false,
		moveItemsAcrossAllLevels = false,
		assignCollaborators = false,
		deleteLastRoundAnyUploader = false
	} ) {
		this.see = see;
		this.upload = upload;
		this.destroy = destroy;
		this.approve = approve;
		this.seeVersions = seeVersions;
		this.filter = filter;
		this.editTitle = editTitle;
		this.moveItemsAcrossAllLevels = moveItemsAcrossAllLevels;
		this.assignCollaborators = assignCollaborators;
		this.deleteLastRoundAnyUploader = deleteLastRoundAnyUploader;
	}
}

export const ownerAssetsPermissions = new AssetsPermissions( {
	see: true,
	upload: true,
	destroy: true,
	approve: true,
	seeVersions: true,
	filter: true,
	editTitle: true,
	moveItemsAcrossAllLevels: true,
	assignCollaborators: true,
	deleteLastRoundAnyUploader: true
} );

export const projectManagerAssetsPermissions = new AssetsPermissions( {
	see: true,
	upload: true,
	destroy: true,
	approve: true,
	seeVersions: true,
	filter: true,
	editTitle: true,
	moveItemsAcrossAllLevels: true,
	assignCollaborators: true,
	deleteLastRoundAnyUploader: true
} );

export const projectEditorAssetsPermissions = new AssetsPermissions( {
	see: true,
	upload: true,
	destroy: true,
	approve: true,
	seeVersions: true,
	filter: true,
	editTitle: true,
	moveItemsAcrossAllLevels: true,
	assignCollaborators: false
} );

export const projectReviewerAssetsPermissions = new AssetsPermissions( {
	see: true,
	upload: false,
	destroy: false,
	approve: true,
	seeVersions: true,
	filter: true,
	editTitle: false,
	moveItemsAcrossAllLevels: false,
	assignCollaborators: false
} );

export const nullAssetsPermissions = new AssetsPermissions( {
	see: false,
	upload: false,
	destroy: false,
	approve: false,
	seeVersions: false,
	filter: false,
	editTitle: false,
	moveItemsAcrossAllLevels: false,
	assignCollaborators: false
} );
